function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import Colors from "styles/colors";
import PersonalTextualInfoDefaultProps from "segments/desktop/core-components/person-textual-info/default-props";
export default _object_spread({
    title: "“The virtual manager that all work needs“",
    fontSize: "24px",
    showStars: true,
    starsCount: 5,
    decorationColor: "iris",
    reviewCardOverrideHeight: null
}, PersonalTextualInfoDefaultProps);
